import Person from "@mui/icons-material/Person";
import { Box, Collapse, Grid, MenuItem, TextField } from "@mui/material";
import { allCountries } from "country-telephone-data";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation } from "react-router-dom";
import ExpandBox from "../components/ExpandBox";
import PageLoader from "../components/Loader";
import Title from "../components/PageTitle";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
const ClinicDetail = () => {
  const [isLoader, setIsLoader] = useState(false);
  const location = useLocation();
  const isMobile = useIsMobile();
  const { doctorId,clinicName } = location.state || {}; // Destructure state data

  const token = localStorage.getItem("token");

  const [clinic, setClinics] = useState([]);
  const [selectedClinicIndex, setSelectedClinicIndex] = useState(0);

  // Select the react-datepicker-wrapper class
  const datePickerWrapper = document.querySelector(".react-datepicker-wrapper");
 
  if (datePickerWrapper) {
    // Set the width to 100%
    datePickerWrapper.style.width = "100%";
  }

  const [openSections, setOpenSections] = useState({
    cliDetails: true,
    logo: true,
  });

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
 
  const [clinicDetails, setClinicDetails] = useState({
    clinicId: "",
    clinicName: "",
    address: "",
    clinicCountryCode: "",
    clinicMobile: "",
    email: "",
    website: "",
    validTill: null,
    city: "",
    state: "",
    country: "",
    mapLink: "",
    mediaDriveLink: "",
  });
  const [logo, setLogo] = useState("");

  const populateClinicDetails = (clinic, details = {}) => {
    setClinicDetails({
      clinicId: clinic._id || "NA",
      clinicName: clinic.name || "No Clinic Name found",
      address: clinic.address || "No address",
      clinicCountryCode: clinic.countryCode || "N/A",
      clinicMobile: clinic.mobile || "No Number Found",
      email: clinic.email || "No email",
      website: details.websiteUrl || clinic.website || "No website found",
      city: clinic.city || "Not found",
      state: clinic.state || "Not found",
      country: clinic.country || "Not found",
      mapLink: clinic.mapsLink || "Not found",
      validTill: formattedDate,
      mediaDriveLink:
        details.mediaDriveLink || clinic.mediaDriveLink || "Not Found",
    });
  };
  let formattedDate = null;

  const getDoctorDetails = async (doctorId) => {
    try {
      setIsLoader(true);
      const details = await apiService.fetchDoctorDetails(doctorId, token);
      console.log("*************API Response: ", details);

      if (details.validTill) {
        const date = new Date(details.validTill);
        if (!isNaN(date.getTime())) {
          formattedDate = date; // Store as Date object
        } else {
          console.warn("Invalid `validTill` value:", details.validTill);
        }
      } else {
        console.warn("Missing `validTill` value in response");
      }

      const loadedClinics = details.clinics || [];
      setClinics(loadedClinics);

      if (loadedClinics.length > 0) {
        setSelectedClinicIndex(0); // make sure to reset index
        populateClinicDetails(loadedClinics[0], details); // pass full details if needed
      }
      //  setKioskId(kiosk._id || "N/A");

     
      setLogo(details.logoUrl || "");
    } catch (error) {
      console.error("Error in getDoctorDetails: ", error);
    } finally {
      setIsLoader(false);
    }
  };

  useEffect(() => {
    if (doctorId) {
      getDoctorDetails(doctorId);
    }
  }, [doctorId]);

  return (
    <div>
      <Box sx={{ padding: isMobile ? 2 : 4 }}>
        <Title icon={<DomainAddIcon />} text={clinicName ||"Clinic Details"} />

        {/* Clinic Details */}
        <ExpandBox
          title="Clinic Details"
          isOpen={openSections.cliDetails}
          toggle={() => toggleSection("cliDetails")}
        >
          {clinic.length > 1 && (
            <TextField
              select
              label="Select Clinic"
              value={selectedClinicIndex}
              onChange={(e) => {
                const index = parseInt(e.target.value, 10);
                setSelectedClinicIndex(index);
                populateClinicDetails(clinic[index]);
              }}
              sx={{ mb: 3, width: "100%" }}
            >
              {clinic.map((clinic, index) => (
                <MenuItem key={clinic.name + index} value={index}>
                  {clinic.name || `Clinic ${index + 1}`}
                </MenuItem>
              ))}
            </TextField>
          )}

          <Collapse in={openSections.cliDetails}>
            {/* Row 1 */}
            <Grid container spacing={3} sx={{ mb: 2 }} display={"flex"}>
              <Grid sx={{ flex: 1 }}>
                <TextField
                  label="Clinic Name"
                  name="clinicName"
                  value={clinicDetails.clinicName}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid sx={{ flex: 1 }}>
                <TextField
                  select
                  label="Country Code"
                  name="clinicCountryCode"
                  value={clinicDetails.clinicCountryCode}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                >
                  {allCountries.map((country) => (
                    <MenuItem
                      key={country.dialCode + country.iso2}
                      value={`+${country.dialCode}`}
                    >
                      {country.name} (+{country.dialCode})
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid sx={{ flex: 1 }}>
                <TextField
                  label="Mobile"
                  name="clinicMobile"
                  value={clinicDetails.clinicMobile}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>

            {/* Row 2 */}
            <Grid container spacing={3} sx={{ mb: 2 }} display={"flex"}>
              <Grid sx={{ flex: 1 }}>
                <TextField
                  label="Address"
                  name="address"
                  value={clinicDetails.address}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid sx={{ flex: 1 }}>
                <TextField
                  label="City"
                  name="city"
                  value={clinicDetails.city}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid sx={{ flex: 1 }}>
                <TextField
                  label="State"
                  name="state"
                  value={clinicDetails.state}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>

            {/* Row 3 */}
            <Grid container spacing={3} sx={{ mb: 2 }} display={"flex"}>
              <Grid sx={{ flex: 1 }}>
                <TextField
                  label="Map Link"
                  name="mapLink"
                  value={clinicDetails.mapLink}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid sx={{ flex: 1 }}>
                <TextField
                  label="Email"
                  name="email"
                  value={clinicDetails.email}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid sx={{ flex: 1 }}>
                <TextField
                  label="Website"
                  name="website"
                  value={clinicDetails.website}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>
          </Collapse>
        </ExpandBox>

        {/* Logo */}
        <ExpandBox
          title="Clinic Logo"
          isOpen={openSections.logo}
          toggle={() => toggleSection("logo")}
        >
          <Collapse in={openSections.logo}>
            <Grid item xs={12} sx={{ textAlign: "left" }} mb={2} mt={1}>
              <img
                src={logo}
                alt="Clinic Logo"
                style={{
                  width: "180px",
                  height: "auto",
                  objectFit: "contain",
                  borderRadius: "10px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                }}
              />
            </Grid>
          </Collapse>
        </ExpandBox>
      </Box>

      {isLoader && <PageLoader />}
    </div>
  );
};

export default ClinicDetail;
